/**
 * Could be more roles floating around - these are the ones in core. I think there's CRM department admin
 * around somewhere.
 */
export type Role = (typeof Roles)[keyof typeof Roles];
export const Roles = {
  INTERNAL_ADMIN: "*",
  SUPER_ADMIN: "super_admin",
  PERMIT_ADMIN: "permits_admin",
  PERMIT_USER: "permits_user",
  INSPECTIONS_USER: "inspections_user",
  INSPECTIONS_ADMIN: "inspections_admin",
  CE_ADMIN: "ce_admin",
  CE_USER: "ce_user",
  COMMUNICATION_ADMIN: "communications_admin",
  CRM_ADMIN: "crm_admin",
  CRM_DEPARTMENT_ADMIN: "crm_department_admin",
  CRM_USER: "crm_user",
} as const;
